<template>
  <div class="website-bd tb" v-if="funcView.website_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 操作项 -->
        <el-form-item>
          <el-button type="primary" v-if="funcView.website_add" icon="el-icon-plus" @click="addWebSite()">{{ funcView.website_add }}</el-button>
        </el-form-item>
        <!-- 导出 -->
        <el-form-item v-if="funcView.website_export" style="float: right; margin-right: 0">
          <el-dropdown>
            <el-button class="table-set" style="vertical-align: top" @click.native="exportTable('SiteExport', formSearch)"><i class="icon icon-daochu"></i></el-button>
          </el-dropdown>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right" :class="{ 'mr-0': !funcView.website_export }">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_website.zdmczdbhdz')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="getTableList" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('dms_website.chuang_jian_fang_shi')">
          <custom-select v-model="formSearch.createMode" code="site_create_mode" placeholder=""></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_website.suo_shu_zu_zhi')">
          <el-input v-model="formSearch.orgName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_website.shi_qu')">
          <custom-select type="tree" filterable :dataFilter="pathTransTree" v-model="formSearch.timezone" code="roc_timezone" :props="{ label: 'name', value: 'value' }"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_website.Pagerpin_dao')">
          <el-input v-model="formSearch.pagerChannel"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_website.geng_xin_shi_jian')">
          <custom-date-picker
            style="width: 100%"
            v-model="formSearch.gmtModified"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
            :start-placeholder="$t('dms_website.kai_shi_ri_qi')"
            :end-placeholder="$t('dms_website.jie_shu_ri_qi')"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('dms_website.ji_huoID')">
          <el-input v-model="formSearch.activationId"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table height="100%" :data="tableList" :column="tableColumn" @filter="filterChange" @sort="sortChange" :slots="['createMode']">
        <template v-slot:createMode="scope">
          <el-popover placement="top-start" title width="300" trigger="click" :content="$t('dms_website.ji_huoIDo', [scope.row.activationId])" v-if="`${scope.row.createMode}` === '1'">
            <el-button slot="reference" type="text" size="mini">{{ getDicValue('site_create_mode', scope.row.createMode) }}</el-button>
          </el-popover>
          <span v-else>{{ getDicValue('site_create_mode', scope.row.createMode) }}</span>
        </template>
        <!-- 操作列 -->
        <el-table-column :label="$t('Common.com_handle')" fixed="right" min-width="120">
          <template slot-scope="scope">
            <el-button type="text" size="mini" v-if="funcView.website_edit && scope.row.createMode === 2 && scope.row.isAllowEdit === 1" @click="editWebSite(scope.row)">
              {{ funcView.website_edit }}
            </el-button>
            <el-button type="text" size="mini" v-if="funcView.website_bind_device" @click="bindDevice(scope.row)">{{ funcView.website_bind_device }}</el-button>
            <el-button type="text" size="mini" v-if="funcView.website_delete && scope.row.createMode === 2 && scope.row.isAllowDelete === 1" @click="deleteWebSite(scope.row)">
              {{ funcView.website_delete }}
            </el-button>
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 新增编辑站点 -->
    <website-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getTableList()"></website-dialog>
    <!-- 关联设备 -->
    <bind-device-dialog v-if="dialogVisible1" :model="dialogModel1" @close="closeBindSite()" @success="getTableList()"></bind-device-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import websiteDialog from '@/pages/dms/components/websiteDialog.vue';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import bindDeviceDialog from './children/bind_device_dialog.vue';

export default {
  name: 'website',
  mixins: [resetFormSearchMixins],
  components: { websiteDialog, bindDeviceDialog },
  data() {
    return {
      tableCode: 'websiteManage',
      provide: true,
      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,

        // 高级筛选
        createMode: 2,
        orgName: '',
        timezone: [],
        pagerChannel: '',
        gmtModified: '',
        activationId: '',
      },

      tableList: [],
      totalRows: 0,

      dialogVisible: false,
      dialogModel: {},
      // dialogData: {},

      dialogVisible1: false,
      dialogModel1: {},
      // dialogData1: {},
      link: null,
    };
  },
  mounted: function () {
    this.getTableColumn();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getTableList();
  },
  methods: {
    getReqData() {
      const timezone = this.formSearch.timezone.join('/');
      const ret = { ...this.formSearch, timezone };
      if (this.formSearch.gmtModified.length) {
        ret.startTime = this.formSearch.gmtModified[0];
        ret.endTime = this.formSearch.gmtModified[1];
        delete ret.gmtModified;
      }
      return ret;
    },
    // 获取表格数据
    getTableList: function () {
      this.$getJSON(apis.SitePage, this.getReqData()).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 路径字符串转树
    pathTransTree(arr) {
      let list = arr.map(t => t.value);
      list = list.map(t => t.split('/').map((f, i) => ({ name: f, value: f, parent: i ? t.split('/')[i - 1] : 0 })));
      list = list.reduce((pre, item) => [...pre, ...item], []);
      list = [...new Set(list.map(t => JSON.stringify(t)))].map(f => JSON.parse(f));
      const tree = list.filter((parent) => {
        const branchArr = list.filter(child => parent.name === child.parent);
        if (branchArr.length > 0) {
          parent.children = branchArr;
        }
        return parent.parent === 0;
      });
      return tree;
    },
    // 关闭关联设备弹窗
    closeBindSite: function () {
      this.dialogVisible1 = false;
      this.getTableList();
    },
    // 新增
    addWebSite: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('dms_website.xin_zeng_zhan_dian');
      this.dialogVisible = true;
    },
    // 编辑
    editWebSite: function (data) {
      this.dialogModel = { type: 'edit', title: this.$t('dms_website.bian_ji_zhan_dian'), row: data };
      // this.dialogData.row = data;
      this.dialogVisible = true;
    },
    // 关联设备
    bindDevice: function (data) {
      this.dialogModel1 = { title: this.$t('dms_website.ybddsb'), row: data };
      this.dialogVisible1 = true;
    },
    // 删除
    deleteWebSite: function (data) {
      this.$showConfirm(this.$t('dms_website.nqdyscxzdzdm')).then(() => {
        this.$postJSON(`${apis.SiteDelete}/${data.siteId}`)
          .then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          })
          .catch(() => {});
      });
    },
  },
};
</script>

<style lang="scss"></style>
